import { render } from "./chemicals.vue?vue&type=template&id=7c843f42&scoped=true&ts=true"
import script from "./chemicals.vue?vue&type=script&lang=ts"
export * from "./chemicals.vue?vue&type=script&lang=ts"

import "./chemicals.vue?vue&type=style&index=0&id=7c843f42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c843f42"]])

export default __exports__